<mat-card>
  <mat-card-header>
    <mat-card-title>CONTACT DETAILS</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form class="contact_form" [formGroup]="contactForm">
      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="first_name">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="last_name">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>E-mail address</mat-label>
        <input matInput formControlName="email">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Phone number</mat-label>
        <input matInput formControlName="phone" placeholder="(XXX) XXX-XXXX" mask="(000) 000-0000">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Agency</mat-label>
        <mat-select formControlName="agency_id" (selectionChange)="updateValidators($event.value, 'agency_id')">
          @for (agency of agencies; track agency) {
          <mat-option [value]="agency.value">{{agency.text}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div style="flex:70%"></div>
      <div class="location-info">
        <div class="subtitle" *ngIf="(contactForm.controls['agency_id'].getRawValue() ?? 0) == 0">
            <b>Organizational Unit Location</b>
        </div>
        <div class="title-form" *ngIf="(contactForm.controls['agency_id'].getRawValue() ?? 0) != 0">Location
            <span class="gray-text">(Closest Forest Service Office)</span>
        </div>
        <mat-radio-group formControlName="location_id" class="radio-buttons"
            (change)="updateValidators($event.value, 'location_id')">
            <mat-radio-button [value]="0" color="primary" class="radio-button">Forest Office</mat-radio-button>
            <mat-radio-button [value]="1" color="primary">Regional Office</mat-radio-button>
            <mat-radio-button [value]="2" color="primary"
                *ngIf="contactForm.controls['agency_id'].getRawValue() == 0">Washington Office</mat-radio-button>
        </mat-radio-group>
        <div class="sub-location"
            *ngIf="contactForm.controls['location_id'].getRawValue() == 0 || contactForm.controls['location_id'].getRawValue() == 1">
            <mat-form-field appearance="outline">
                <mat-label>Region</mat-label>
                <mat-select formControlName="region" (selectionChange)="regionChanged()">
                    @for (region of regions; track region) {
                    <mat-option [value]="region">{{region}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" *ngIf="contactForm.controls['location_id'].getRawValue() == 0"
                style="width: 50%">
                <mat-label>Forest Name</mat-label>
                <input #forest matInput formControlName="forest_name" [matAutocomplete]="auto"
                    (input)="filter()" (focus)="clearForest()">
                <mat-autocomplete requireSelection #auto="matAutocomplete"
                    (optionSelected)="forestNameSelected($event)">
                    @for (name of filtered_forest_names | async; track name) {
                    <mat-option [value]="name">{{name | forest_filter}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
    <div class="location-info" *ngIf="(contactForm.controls['agency_id'].getRawValue() ?? 0) == 0">
        <div class="subtitle" style="margin-top: 10px;">
            <b>Duty Station Location</b>
        </div>
        <mat-radio-group formControlName="duty_location_id" class="radio-buttons"
            (change)="updateValidators($event.value, 'duty_location_id')">
            <mat-radio-button [value]="0" color="primary" class="radio-button">Forest Office</mat-radio-button>
            <mat-radio-button [value]="1" color="primary">Regional Office</mat-radio-button>
            <mat-radio-button [value]="2" color="primary"
                *ngIf="contactForm.controls['agency_id'].getRawValue() == 0">Washington Office</mat-radio-button>
        </mat-radio-group>
        <div class="sub-location"
            *ngIf="contactForm.controls['duty_location_id'].getRawValue() == 0 || contactForm.controls['duty_location_id'].getRawValue() == 1">
            <mat-form-field appearance="outline">
                <mat-label>Region</mat-label>
                <mat-select formControlName="duty_region" (selectionChange)="regionChanged_duty()">
                    @for (region of regions; track region) {
                    <mat-option [value]="region">{{region}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline"
                *ngIf="contactForm.controls['duty_location_id'].getRawValue() == 0" style="width: 50%">
                <mat-label>Forest Name</mat-label>
                <input #forest matInput formControlName="duty_forest_name" [matAutocomplete]="auto"
                    (input)="filter_duty()" (focus)="clearForest_duty()">
                <mat-autocomplete requireSelection #auto="matAutocomplete"
                    (optionSelected)="forestNameSelected_duty($event)">
                    @for (name of filtered_forest_names_duty | async; track name) {
                    <mat-option [value]="name">{{name | forest_filter}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
      <div class="flex:20%">&nbsp;</div>
    </form>
  </mat-card-content>
  <mat-dialog-actions>
    <div class="button-row">
      <button class="usa-button" [disabled]="!contactForm.valid" (click)="save()">Save</button>
      <button class="usa-button usa-button--secondary" (click)="cancel()">Cancel</button>
    </div>
  </mat-dialog-actions>
</mat-card>